"use client";
import { useRef } from "react";
import { useParams } from "next/navigation";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { useDictionary } from "../../context/dictionaryProvider";

const PhoneField = ({
  label,
  isInvalid,
  errorMessage,
  name,
  value,
  onChange,
}) => {
  const dict = useDictionary();

  let currentCountry = "AE";
  if (typeof window !== "undefined") {
    currentCountry = localStorage?.getItem("countryCode") ?? "AE";
  }

  const params = useParams();
  const wrapRef = useRef(null);
  const countryRef = useRef(null);

  const handlePhoneChange = (phone, metadata) => {
    // A changed country code is announced to the form's tracking
    // (useFormTracking listens for it); the first value is the default.
    const iso2 = metadata?.country?.iso2;
    if (iso2) {
      if (countryRef.current && countryRef.current !== iso2 && wrapRef.current) {
        wrapRef.current.dispatchEvent(
          new CustomEvent("lp-country-select", {
            bubbles: true,
            detail: { country_code: iso2.toUpperCase(), country: metadata.country.name },
          })
        );
      }
      countryRef.current = iso2;
    }

    if (onChange) {
      onChange(phone, metadata);
    }
  };

  return (
    <div className="mb-4" data-nosnippet ref={wrapRef}>
      <label className="block text-sm font-semibold leading-6 text-black-900 mb-1 capitalize">
        {label}
      </label>
      <PhoneInput
        inputProps={{ dir: "ltr" }}
        name={name}
        placeholder={dict?.form?.placeholders?.typeHere}
        className="border-b-1 direction-ltr"
        inputClassName="!border-none !text-left direction-ltr"
        value={value}
        onChange={handlePhoneChange}
        defaultCountry={currentCountry?.toLowerCase() ?? "ae"}
        countrySelectorStyleProps={{
          buttonClassName: "!border-none",
          dropdownStyleProps: {
            className: `${
              params?.lang === "ar" ? "left-auto right-0" : ""
            } !z-[999] w-full`,
          },
        }}
      />
      {errorMessage && isInvalid && (
        <div className="group-data-[has-helper=true]:flex relative flex-col gap-1.5 p-0 mt-2">
          <div className="text-tiny text-red-500">{errorMessage}</div>
        </div>
      )}
    </div>
  );
};

PhoneField.displayName = "PhoneField";

export default PhoneField;
